import {Component, inject, viewChild} from '@angular/core';
import {environment} from "../../../environments/environment";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {AccessService} from "../../services/access.service";
import {FormsModule} from "@angular/forms";
import {ModalDirective} from "ngx-bootstrap/modal";
import {NgIf} from "@angular/common";
import {DataService} from "../../services/data.service";
import {ToastrService} from "ngx-toastr";
import {LocalStorageService} from "../../services/local-storage.service";

@Component({
  selector: 'app-admin-navigation',
    imports: [
        RouterLink,
        FormsModule,
        ModalDirective,
        NgIf
    ],
  templateUrl: './admin-navigation.component.html',
  styleUrl: './admin-navigation.component.scss'
})
export class AdminNavigationComponent {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);
    private localStorageService = inject(LocalStorageService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    protected readonly environment = environment;

    clientModal = viewChild.required<ModalDirective>('clientModal');

    client: any;

    logout() {
        this.dataService.request('Client/logout').subscribe(response => {
            if (response.error) {
                this.toastrService.error(response.error, 'Fehler');
            } else {
                this.router.navigate(['../login'], {relativeTo: this.route});
                this.toastrService.success('Abmelden erfolgreich', 'Logout');
                this.localStorageService.removeItem('token');
                this.accessService.client = null;
                this.accessService.token = '';
            }
        });
    }

    showClientModal() {
        this.client = this.accessService.client;
        this.clientModal().show()
    }

    closeClientModal() {
        this.client.name = this.accessService.client.name;
        this.client.email = this.accessService.client.email;
        this.client.password = '';
        this.client.passwordConfirm = '';
        this.clientModal().hide();
    }

    updateClient() {
        this.dataService.request('Client/update', {
            client: this.client
        }).subscribe(response => {
            this.toastrService.success('Mandant wurde aktualisiert', 'Erfolg');
            this.clientModal().hide();

            this.accessService.client.name = this.client.name;
            this.accessService.client.email = this.client.email;
        })
    }

}
